import React from 'react';
import { Switch, Route, BrowserRouter as Router, Redirect } from 'react-router-dom';

import MainPage from './my-jeeva/MainPage';
import LoginPage from './my-jeeva/login/LoginPage'
import Signup from './my-jeeva/projectmgmt/Signup';
import ContentPreview from './my-jeeva/projectmgmt/ContentPreview';
import DeleteAccount from './my-jeeva/DeleteAccount';
import ResetPassword from './my-jeeva/login/ResetPassword';
import GenerateAndVerifyOtp from './my-jeeva/login/GenerateAndVerifyOtp';
import ErrorBoundary from './ErrorBoundary';
import ChangeLog from './my-jeeva/projectmgmt/ChangeLog';
import ProviderPortalDoc from './my-jeeva/projectmgmt/ProviderPortalDoc';
import CookiePolicy from './my-jeeva/projectmgmt/CookiePolicy';
import PrivacyPolicy from './my-jeeva/projectmgmt/PrivacyPolicy';
import TermsOfService from './my-jeeva/projectmgmt/TermsOfService';


const ProtectedRoute = ({ component: Component, ...rest }) => {
  const userDetails = localStorage.getItem("user_details");

  return (
    <Route
      {...rest}
      render={() =>
        userDetails ? (
          <Component />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};


const Main = () => {
  window.SCOPE_VALUE = {
    ADMIN: 10,
    HEALTHSYSTEM_ADMIN: 9,
    HOSPITAL_ADMIN: 8,
    SERVICELINE_ADMIN: 7,
    PROCEDURE_ADMIN: 6,
    PHYSICIAN: 5,
    NURSE: 4,
    PATIENT: 3
  }
  if (localStorage.getItem("currentScope")) {
    window.SCOPE_VALUE.CURRENT = localStorage.getItem("currentScope");
  }
  return (
    <ErrorBoundary>
      <Router basename={window.contextPath}>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route path='/signup' component={Signup}></Route>
          <Route path='/resetpassword' component={ResetPassword}></Route>
          <Route path='/forgotpassword' component={GenerateAndVerifyOtp}></Route>
          <Route path='/delete-account' component={DeleteAccount}></Route>
          <Route exact path='/login' component={LoginPage}></Route>
          {/* <Route path='/projectmgmt' component={MainPage}></Route> */}
          <Route path='/app-content-preview' component={ContentPreview}></Route>
          <Route exact path='/change-log' component={ChangeLog}></Route>
          <Route exact path='/portal-overview' component={ProviderPortalDoc}></Route>
          <Route exact path='/cookie-policy' component={CookiePolicy}></Route>
          <Route exact path='/privacy-policy' component={PrivacyPolicy}></Route>
          <Route exact path='/terms-of-service' component={TermsOfService}></Route>

          {/* <Route
            path={["/projectmgmt"]}
            component={MainPage}
          /> */}

          <ProtectedRoute path="/projectmgmt" component={MainPage} />


        </Switch>
      </Router>
    </ErrorBoundary>
  );
}
export default Main;


// WEBPACK FOOTER //
// src/Main.js